import React from "react";
import PropTypes from "prop-types";
import StoryCardDL1MP54 from "../../atoms/story-card-dl-1-ml-5-4";
import StoryCardDP95MP32 from "../../atoms/story-card-dp-9-5-mp-3-2";
import StoryCardDP95MP95 from "../../atoms/story-card-dp-9-5-mp-9-5";
import StoryCardDL43ML54 from "../../atoms/story-card-dl-4-3-ml-5-4";

import styles from "./styles.m.css";
import { VikatanMainResponsive } from "../ad-free";

const FiveStory = ({ stories, accentColor, pagetype = "" }) => {
  return (
    <div className={`${styles["base"]}`} style={accentColor && { "--accent-color": accentColor }}>
      <div>
        <div className={`${styles["row"]}`}>
          <div className={styles["main-content"]}>
            <StoryCardDP95MP32 story={stories[0]} />
          </div>
          <div className={styles["second-column"]}>
            {!!stories[1] && <StoryCardDP95MP95 story={stories[1]} />}
            {!!stories[2] && <StoryCardDL43ML54 story={stories[2]} />}
          </div>
          <div className={styles["third-column"]}>
            <VikatanMainResponsive
              placement="magazine-landing-page"
              MobileAdtype="Vikatan_mrec_mid_SP"
              DesktopAdtype="Vikatan_Desktop_SP_ATF_Right_300x250"
            />
            <div className={styles["bottom-aligned"]}>{!!stories[3] && <StoryCardDL1MP54 story={stories[3]} />}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

FiveStory.propTypes = {
  accentColor: PropTypes.string,
  stories: PropTypes.shape(),
  pagetype: PropTypes.string
};
FiveStory.storyLimit = 5;

export default FiveStory;
